'use strict';

var dictionary = {
  I: 'DD',
  A: 'AC',
  Z: 'ZS'
};

module.exports = function (key) {
  return dictionary[key];
};
